<template>
  <div class="chart-bar" />
</template>

<script>
import chartInitMixin from '@/views/mixin/chartInitMixin'
import * as echarts from 'echarts'
export default {
  name: 'chart-bar-percent', // 通信协议Top5
  props: {
    chartData: {
      type: Number,
      required: true,
    },
    chartColor: {
      type: Array,
      required: false,
      default: [ '#00b6e7', '#293F5E' ],
    }
  },
  mixins: [ chartInitMixin, ],
  watch: {
    'chartData': {
      deep: true,
      handler() {
        this.update()
      }
    },
  },
  methods: {
    update() {
      if(!this.chartData) return
      const percent = this.chartData
      const option = {
        color: '#20a5fe',
        fontSize: 12,
        fontFamily: '"OPPOSans R",sans-serif',
        tooltip: {
          show: false,
        },
        grid: {
          left: 0,
          right: 0,
        },
        legend: {
          show: false,
        },
        yAxis: [
          {
            show: false,
            type: 'category',
          },
        ],
        xAxis: [
          {
            show: false,
            type: 'value',
            position: 'left',
            min: 0,
            max: 100,
            axisLabel: {
              show: false,
            },
          },
        ],
        series: [
          {
            type: 'bar',
            barWidth: 20,
            color: this.chartColor[0],
            showBackground: true,
            backgroundStyle: {
              color: this.chartColor[1],
            },
            itemStyle: {
              color: this.chartColor[0],
            },
            z: 0,
            zlevel: 1,
            data: [ percent ]
          },
        ]
      }
      this.chart.setOption(option)
      // console.log('#option#', option)
    }
  }
}
</script>
